<template lang="pug">
    d2-container()
        el-row(style="padding-bottom:15px;" :span="24")
          el-col(:md='22' :sm="12")
            //- v-if="isAuth('pb:news:add')"
            el-button(@click='addModify()' type='primary') 新建配置
            el-button(@click='btn_del()' type='primary' :disabled="!btn_delStaus") 删除
        el-table(:data="tableData" id="out-table" style="width: 100%" , @selection-change='selectionChangeHandle' v-loading='dataListLoading' border)
            el-table-column( type='selection', header-align='center', align='center', width='50')
            el-table-column(label='培训类型' prop='trianType_label' header-align='center' align='center')
            el-table-column(label='允许请假' prop='status' header-align='center' align='center')
              template(slot-scope="scope")
                span() {{scope.row.status == 1?'允许':'不允许'}}
            el-table-column(label='补课券类型' prop='couponType_label' header-align='center' align='center')
            el-table-column(label='适用培训类型' prop='couponApplyType_label' header-align='center' align='center')
            el-table-column(prop='',header-align='center',align='center',label='操作' width='100')
              template(slot-scope="scope")
                el-menu.menuPonit(:collapse="isCollapse")
                  el-submenu(index="1")
                      template(slot="title")
                          i(class="el-icon-more" style='color:#02B90D;')
                      el-menu-item-group()
                          el-menu-item(index="1-1" v-if="isAuth('leave:info:detail')" @click="viewDetail(scope.row)") 查看详情
                          el-menu-item(index="1-2" v-if="isAuth('leave:info:update')" @click="addModify(scope.row)") 修改
                          el-menu-item(index="1-3" v-if="isAuth('leave:info:delete')" @click='deleteItem(scope.row)') 删除
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        AddModify(v-show="partnerVisible" ref="AddModify" @getDataList="getDataList")
        viewDetail(v-show="viewDetailVisible" ref="viewDetail")
</template>
<script>
import { Gettrianset, ManagePartner } from '@/api/pages/train/trainVacate';
export default {
  props: ['which'],
  components: {
    AddModify: () => import('./addModify.vue'),
    viewDetail: () => import('./viewDetail.vue')
  },
  data () {
    return {
      train_list: [
        {
          label: '分级整期培训',
          value: 1
        },
        {
          label: '青少年儿童培训',
          value: 2
        },
        {
          label: '定制化个人培训-个人培训',
          value: 3
        },
        {
          label: '定制化个人培训-团体培训',
          value: 4
        }
      ],
      lesson_list: [
        {
          label: '分级整期培训',
          value: 1
        },
        {
          label: '青少年儿童培训',
          value: 2
        }
      ],
      tableData: [],
      delTableList: null, //多选框选中
      btn_delStaus: false, //删除按钮状态
      dataListLoading: false,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      isCollapse: true,
      partnerVisible: false,
      viewDetailVisible: false
    };
  },
  mounted () {
    this.getDataList();
  },
  methods: {
    addModify (row) {
      this.partnerVisible = true;
      this.$refs.AddModify.init(row);
    },
    viewDetail (row) {
      this.viewDetailVisible = true;
      this.$refs.viewDetail.init(row);
    },
    btn_del () {
      let list = this.delTableList.map(item => {
        let obj = { configId: item.configId };
        return obj;
      });
      let info = {
        list,
        tip: '此操作将永久删除已选中培训请假设置, 是否继续?'
      };
      this.tip(info);
    },
    getDataList () {
      this.dataListLoading = true;
      Gettrianset().then(res => {
        res.data.forEach(item => {
          // 处理培训类型
          item.trianType_label = this.create_label(item.trianType, false);
          // 处理补课券类型
          if (item.couponType) {
            item.couponType_label = this.create_label(item.couponType, true);
            // 处理补课券适用培训类型
            let couponApplyType = item.couponApplyType || ''
            let arr = couponApplyType.split(',');
            item.couponApplyType_label =arr.map(which => this.create_label(which,false)).join(',');
          } else {
            item.couponType_label = '-';
            item.couponApplyType_label = '-';
          }
        });
        this.tableData = res.data;
        this.dataListLoading = false;
      }).catch(error =>{
        console.error('error',error)
        this.dataListLoading = false;
      })
    },
    deleteItem (row) {
      let arr = [];
      let obj = { configId: row.configId };
      arr.push(obj);
      let info = {
        list: arr,
        tip: '此操作将永久删除该培训请假设置, 是否继续?'
      };
      this.tip(info);
    },
    tip (info) {
      let { tip, list } = info;
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          flag: 2,
          data: list
        };
        ManagePartner(data).then(res => {
          this.getDataList();
        });
      });
    },
    // table多选框选中
    selectionChangeHandle (val) {
      console.log(val,'val=====>')
      this.delTableList = val;
      this.btn_delStaus = !!this.delTableList.length;
      console.log('this.btn_delStaus:',this.btn_delStaus)
    },
    // 分页器
    currentChangeHandle (val) {
      this.pageIndex = val;
      this.getDataList();
    },
    sizeChangeHandle (val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    create_label (which, type) {
      which = which + '';
      let assign = '';
      switch (which) {
        case '1':
          assign = '分级单次培训';
          break;
        case '2':
          assign = '分级整期培训';
          break;
        case '3':
          assign = '青少年儿童培训';
          break;
        case '4':
          assign = '个人定制化培训';
          break;
        case '5':
          assign = '团体定制化培训';
          break;
        default:
          break;
      }
      if (type) {
        assign = assign + '补课券';
      }
      return assign;
    }
  }
  // created () {
  //   this.getDataList();
  // },
};
</script>
<style>
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';
</style>
<style lang="scss" scoped>
</style>
